import { render } from "./AddDepartment.vue?vue&type=template&id=4d749ad0"
import script from "./AddDepartment.vue?vue&type=script&lang=js"
export * from "./AddDepartment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__